import { useSession, signOut } from "../lib/authClient";

export function useAuth() {
  const session = useSession();
  return {
    user: session.data?.user ?? null,
    isLoading: session.isPending,
    isAuthenticated: Boolean(session.data?.user),
    signOut: async () => {
      await signOut();
    },
  };
}
